/**
* Import Gallery
*/
import InitGallery from './components/gallery.js'

/**
* Init - initalises all project classes
*/
class Init{

	constructor(){
		new InitGallery()
	}

}

new Init()
